import Loadable from 'react-loadable';

export default Loadable(() => import('./ContactsEfficiency.route'));
